import { LSTask } from '@orobix/label-studio'
import { formatDistance } from 'date-fns'
import snakecaseKeys from 'snakecase-keys'

import { Annotation } from '../../types/annotation'
import { Observation } from '../../types/observation'

export const makeTask = (
  observation?: Observation,
  annotation?: Annotation,
  username?: string
): LSTask | undefined => {
  const makeCreatedAgo = (createdAt: Date) =>
    formatDistance(new Date(createdAt), new Date())

  if (!observation) return undefined

  return {
    id: observation.id,
    predictions: [],
    annotations: annotation
      ? [
          {
            id: annotation.id,
            created_username: username,
            task: observation.id,
            created_at: annotation.creationDate,
            created_ago: makeCreatedAgo(annotation.creationDate),
            updated_at: annotation.creationDate,
            was_cancelled: false,
            ground_truth: false,
            lead_time: 0,
            completed_by: 1,
            parent_prediction: null,
            parent_annotation: null,
            result: snakecaseKeys(annotation.data),
          },
        ]
      : [],
    data: {
      image: observation.image,
    },
  }
}
